<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">新闻资讯</div>
        <div class="item_small">-NEWS INFORMATION-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">{{ groupName }}</div>
        </div>
      </div>
      <div class="newList_content row-column acea-row row-center-wrapper">
        <newList :newsList="newsList"></newList>
      </div>
    </div>
  </div>
</template>
<script>
import newList from "@/components/newList/index";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/main/news/newsBg1.png"),
      groupName: "公司资讯", //产品类型名称
      newsList: [

      ],
    };
  },
  watch: {},
  components: {
    newList,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;
  background-color: #f3f3f3;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .newList_content {
  padding: 20px 0px;
  width: 100%;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 30px;
  color: #555555;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/newList/company.vue